import { INVOICE_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_INVOICE } from "redux/actionTypes/actionTypes";
import { ADD_INVOICE,GET_INCOMING_ENVELEOP_LIST } from "redux/actionTypes/actionTypes";

const initialState = {
  inComingInvoiceReducer: [],
  invoiceTotal: 0,
};

const inComingInvoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INCOMING_ENVELEOP_LIST:
      return {
        ...state,
        inComingInvoiceReducer: action.payload,
      };
      break;
    case ADD_INVOICE:
      return {
        ...state,
        inComingInvoiceReducer: state.inComingInvoiceReducer.concat(action.payload),
      };
      break;
    case DELETE_INVOICE:
      return {
        ...state,
        inComingInvoiceReducer: state.inComingInvoiceReducer.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case INVOICE_TOTAL:
      return {
        ...state,
        invoiceTotal: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default inComingInvoiceReducer;
